import { useCallback, useState } from "react";
import axios from "axios";
import { API, errorMessage } from "../api";
import { KdsBoard } from "./KdsBoard";
import "../App.css";
import "../india.css";

export default function PublicKitchen({ token }) {
  const [meta, setMeta] = useState({ name: "", city: "" });
  const base = `${API}/public/kds/${token}`;
  const fetchBoard = useCallback(async (served) => {
    const { data } = await axios.get(`${base}?include_served=${served}`);
    setMeta({ name: data.branch_name, city: data.branch_city });
    return data;
  }, [base]);
  const setKot = useCallback((id, status) => axios.put(`${base}/kots/${id}/status`, { status }), [base]);
  const setItem = useCallback((id, itemId, status) => axios.put(`${base}/kots/${id}/items/${itemId}/status`, { status }), [base]);
  return (
    <div className="kds-public" data-testid="kds-public-page">
      <KdsBoard title={meta.name || "Kitchen Display"} subtitle={meta.city ? `${meta.city} · FynDine` : "FynDine"}
        fetchBoard={fetchBoard} setKot={setKot} setItem={setItem} onError={errorMessage} />
    </div>
  );
}
